export default __webpack_public_path__ + "static/media/airPoppedPopcorn.3d748711.jpg";